import { apiSlice, asyncToastDisplay, i18n } from "./apiSlice";

export const extractApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getExtracts: builder.query({
      query: () => `/extracts/`,
      providesTags: (result, error, arg) => [{ type: 'Extract', id: 'LIST' }],
    }),
    getExtract: builder.query({
      query: (extractKey) => `/extracts/${extractKey}`,
      providesTags: (result, error, arg) => [{ type: 'Extract', id: arg }],
    }),
    createExtract: builder.mutation({
      query: (extract) => ({
        url: `/extracts/`,
        method: 'POST',
        body: extract
      }),
      onQueryStarted: asyncToastDisplay({successMessage: i18n.t("toast.created")}),
      invalidatesTags: (result, error, arg) => [{ type: 'Extract', id: 'LIST' }],
    }),
    updateExtract: builder.mutation({
      query: (extract) => ({
        url: `/extracts/${extract.key}`,
        method: 'PUT',
        body: extract,
      }),
      onQueryStarted: asyncToastDisplay({successMessage: i18n.t("toast.updated")}),
      invalidatesTags: (result, error, arg) => [
        { type: 'Extract', id: arg.key }, { type: 'Extract', id: 'LIST' }
      ]
    }),
    runExtract: builder.mutation({
      query: (extractKey) => ({
        url: `/extracts/${extractKey}/run`,
        method: 'POST'
      }),
      onQueryStarted: asyncToastDisplay({successMessage: i18n.t("toast.run")}),
    }),
    deleteExtract: builder.mutation({
      query: (extractId) => ({
        url: `/extracts/${extractId}`,
        method: 'DELETE'
      }),
      onQueryStarted: asyncToastDisplay({successMessage: i18n.t("toast.deleted")}),
      invalidatesTags: (result, error, arg) => [
        { type: 'Extract', id: arg.extractId },
        { type: 'Extract', id: 'LIST' }
      ]
    }),
    getExtractAggregationOptions: builder.query({
      query: () => ({
        url: `/extracts/aggregation_options`
      }),
      providesTags: [{ type: 'AggregationOptions' }],

    })
  }),
  overrideExisting: false
})

export const {
  useGetExtractsQuery,
  useGetExtractQuery,
  useGetExtractAggregationOptionsQuery,
  useCreateExtractMutation,
  useUpdateExtractMutation,
  useDeleteExtractMutation,
  useRunExtractMutation
} = extractApiSlice
